import React, { FC } from 'react';

import TextControl, { TextControlProps } from '../TextControl';
import SearchInput from '../SearchInput';
import { SearchInputProps } from '../SearchInput/SearchInput';

export interface SearchControlProps extends Omit<SearchInputProps, 'Input'> {}

export interface SearchControlStatics {
  labeledControl: boolean;
  publicProps: string[];
}

const SearchControl: FC<SearchControlProps> & SearchControlStatics = (props) => (
  <TextControl {...props as TextControlProps} Input={SearchInput} />
);

SearchControl.labeledControl = true;
SearchControl.publicProps = ['onSearch'];

export default SearchControl;
